import axios from "axios";
import type { AxiosInstance }from "axios"
import {baseApi} from "./base"
const service:AxiosInstance=axios.create({
    baseURL: baseApi,
  // 请求超时时间
  timeout: 100000,
})

export default service;